import { dataTableEvents } from '../constants/data-table-events';

function decorateDetailsCell(
  cell: Node,
  uniqueId: string | null | undefined,
  focusField?: string,
  detailsCellClassName?: string,
): void {
  const cellElement = cell as HTMLElement | null;

  if (!cellElement || !uniqueId) {
    return;
  }

  cellElement.setAttribute(dataTableEvents.common.details, uniqueId);

  if (detailsCellClassName) {
    cellElement.classList.add(detailsCellClassName);
  }

  if (focusField) {
    cellElement.setAttribute(dataTableEvents.common.detailsField, focusField);
  } else {
    cellElement.removeAttribute(dataTableEvents.common.detailsField);
  }
}

function syncActiveDetailsRow(
  tableId: string,
  activeDetailsId: string | null,
  activeRowClassName: string,
): void {
  setTimeout(() => {
    const tableBody = document.querySelector(`#${tableId} tbody`);

    if (!tableBody) {
      return;
    }

    tableBody.querySelectorAll(`tr.${activeRowClassName}`).forEach((row) => {
      row.classList.remove(activeRowClassName);
    });

    if (!activeDetailsId) {
      return;
    }

    const targetCell = tableBody.querySelector(
      `td[${dataTableEvents.common.details}="${activeDetailsId}"]`,
    );

    targetCell?.closest('tr')?.classList.add(activeRowClassName);
  });
}

export { decorateDetailsCell, syncActiveDetailsRow };
